import { Point } from "../../models";

export const communityCardPositions: Point[] = [
  { x: 760, y: 415 },
  { x: 840, y: 415 },
  { x: 920, y: 415 }, // top-left
  { x: 1000, y: 415 },
  { x: 1080, y: 415 },
];
export const r2tT1Positions: Point[] = [
  { x: 805, y: 392 },
  { x: 870, y: 392 },
  { x: 935, y: 392 },
  { x: 1000, y: 392 }, // top-left
  { x: 1065, y: 392 },
];
export const r2tT2Positions: Point[] = [
  { x: 805, y: 479 },
  { x: 870, y: 479 },
  { x: 935, y: 479 },
  { x: 1000, y: 479 }, // top-left
  { x: 1065, y: 479 },
];
export const r2tCardScale: Point = { x: 0.7, y: 0.7 };
export const communityCardScale: Point = { x: 0.85, y: 0.85 };
